/**
 * Search: a Tags tab beside Discussions and Posts, and no "Search options" hints (is:, tag:, author:...).
 * The hints suit power users; members just type words. Typed filters still work.
 *
 * The Tags tab matches tag names (then descriptions) in the browser: every tag is already loaded for the
 * sidebar, so it needs no new endpoint.
 */
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
class TagsSearchSource {
  constructor() {
    this.resource = 'tags';
    this.results = new Map();
  }
  title() {
    return 'Communities';
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  search(query, limit) {
    const q = query.toLowerCase().trim();
    const load = app.tagList && app.tagList.load ? app.tagList.load(['parent']) : Promise.resolve();
    return Promise.resolve(load).catch(() => {}).then(() => {
      const words = q.split(/\s+/).filter(Boolean);
      const scored = [];
      (app.store.all('tags') || []).forEach(tag => {
        if (!tag.name || !tag.slug()) return;
        const name = String(tag.name() || '').toLowerCase();
        const parent = tag.parent && tag.parent() ? String(tag.parent().name() || '').toLowerCase() : '';
        const desc = String(tag.description() || '').toLowerCase();
        let score = 0;
        if (name === q) score = 100;else if (name.startsWith(q)) score = 80;else if (words.every(w => name.includes(w))) score = 60;else if (words.every(w => (name + ' ' + parent).includes(w))) score = 40;else if (words.every(w => desc.includes(w))) score = 20;
        if (score) scored.push([score + Math.min(9, Math.log10((tag.discussionCount() || 0) + 1) * 3), tag]);
      });
      scored.sort((a, b) => b[0] - a[0]);
      this.results.set(q, scored.slice(0, limit || 10).map(s => s[1]));
      m.redraw();
    });
  }
  view(query) {
    return (this.results.get(query.toLowerCase().trim()) || []).map(tag => {
      const parent = tag.parent && tag.parent();
      const color = tag.color() || 'var(--muted-color)';
      const count = tag.discussionCount() || 0;
      return m("li", {
        className: "TagSearchResult",
        "data-index": 'tags' + tag.id(),
        "data-id": tag.id()
      }, m(Link, {
        href: app.route('tag', {
          tags: tag.slug()
        }),
        className: "TagSearchResult-link"
      }, m("span", {
        className: "TagSearchResult-icon",
        style: {
          backgroundColor: color
        }
      }, m("i", {
        className: tag.icon() || 'fas fa-hashtag',
        "aria-hidden": "true"
      })), m("span", {
        className: "TagSearchResult-text"
      }, m("span", {
        className: "TagSearchResult-name"
      }, parent ? m("span", {
        className: "TagSearchResult-parent"
      }, parent.name(), " \u203A ") : null, tag.name()), tag.description() ? m("span", {
        className: "TagSearchResult-desc"
      }, tag.description()) : null), m("span", {
        className: "TagSearchResult-count"
      }, count.toLocaleString('en-US'))));
    });
  }
  customGrouping() {
    return false;
  }
  fullPage() {
    return null;
  }
  gotoItem(id) {
    const tag = app.store.getById('tags', id);
    return tag ? app.route('tag', {
      tags: tag.slug()
    }) : null;
  }
}
app.initializers.add('voucha-theme-search-tags', function () {
  if (!app.store.models || !app.store.models.tags) return; // flarum/tags off
  // after Posts
  extend('flarum/forum/components/GlobalSearch', 'sourceItems', function (items) {
    if (app.forum.attribute('canViewForum')) items.add('tags', new TagsSearchSource(), -10);
  });
  // no "Search options" list
  override('flarum/common/components/SearchModal', 'gambits', function () {
    return [];
  });
});